// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + {"443":"ad7f724d","842":"38a8da06"}[chunkId] + "." + {"443":"c8b5610d8251386b","842":"6db8b59711180ba2"}[chunkId] + ".js";
};